import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/css/VMcss.css'
import './assets/css/style.css'
import store from './components/js/store/index'; // Import Vuex store


createApp(App).use(router).use(store).mount('#app')
